<template>
  <p
    class="sales-funnel-paragraph"
    :class="{ 'is-small': small, 'is-bold': bold }"
  >
    <slot />
  </p>
</template>

<script>
export default {
  name: 'Paragraph',

  props: {
    small: { type: Boolean, required: false, default: false },
    bold: { type: Boolean, required: false, default: false },
  },
};
</script>

<style scoped lang="scss">
@use 'scss-vars';

.sales-funnel-paragraph {
  font-size: 16px;
  line-height: 1.5;
  text-align: center;

  &.is-small {
    font-size: 14px;
    line-height: 1.29;
  }

  &.is-bold {
    font-family: scss-vars.$font-bold;
  }
}
</style>
